export { default as DarkNhShape } from './dark-nh-shape.svg'
export { default as NhShape } from './nh-shape.svg'
